//该modules封装了一些函数，为了减少d1vuecomponent中的代码
let d1FunctionJsModule = {
  d1FunctionJsModule_console: function () {
    console.log("this is d1 模块的JS文件和功能", this)
  },
  d1FunctionJsModule_MyToDoListTicketTypeView: function () {
    if (true) {
      let res = document.getElementsByClassName('ticketTypeClassname')
      //防止bug
      let firstchildren
      let secendchildren
      if (res[0]) {
        if (res[0].childNodes[0]) {
          if (res[0].childNodes[0].childNodes[0]) {
            if (res[0].childNodes[0].childNodes[0].childNodes[0]) {
              firstchildren = res[0].childNodes[0].childNodes[0].childNodes[0]
              secendchildren = res[0].childNodes[0].childNodes[0].childNodes[1]
            }
          }
        }
      }
      if (res) {
        if (firstchildren) {
          let style1 = firstchildren.style
          if (style1) {
            style1.maxWidth = '70%'
            style1.whiteSpace = 'nowrap'
            style1.overflow = 'hidden'
            style1.textOverflow = 'ellipsis'
          }
        }
        if (secendchildren) {
          let style2 = secendchildren.style
          if (style2) {
            style2.whiteSpace = 'nowrap'
            secendchildren.style.maxWidth = '30%'
          }
        }
      }
    }



  },
  d1FunctionJsModule_pageFuzzySearch: function (that, pageSettingDataFormArr, params, defaultSearcheParamsNumber) {
    pageSettingDataFormArr.map(function (item, index, arr) {
      //根据标签名对相应标签进行初始化的响应
      if (item.view_field_label === "Ticket Type") {
        let listparams = item.field_optional_value_list
        //保证数组不是空，不然后面会报错
        if (item.field_optional_value_list.length > 0) {
          //这里分析一下,选中值后使用数组存储
          //默认选中两项
          if (defaultSearcheParamsNumber === 2) {
            item.field_value = [listparams[0].option_value, listparams[1].option_value]
            //默认选中一项
          } else if (defaultSearcheParamsNumber === 1) {
            item.field_value = [listparams[2].option_value]
          }
          for (let i = 0; i < item.field_value.length; i++) {

            that.setParams(params, item.db_field_name, item.field_value[i])
          }
          //this.selectorChange(item.db_field_name, item.field_value)
        }

      }
    })
  }
}
export default d1FunctionJsModule



// WEBPACK FOOTER //
// ./src/components/d1/d1FunctionJsModule.js